import {Modal} from '#/atoms/modal';
import {CopyAddressToClipboardButton} from '#/components/wallet-import/copy-address-to-clipboard-button';
import {Title} from '#/components/wallet-transfer/wallet-transfer-modal';
import {ImportWalletTransactionsContext} from '#/contexts/import-wallet-transactions-provider';
import {ModalContext} from '#/contexts/modal-provider';
import {WalletContext} from '#/contexts/wallet-provider';
import {GlobeAltIcon} from '@heroicons/react/24/outline';
import {FunctionComponent, useContext, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import QRCode from 'react-qr-code';

export const WalletImportModal: FunctionComponent = () => {
  const {
    accountResult: {address, chain},
  } = useContext(WalletContext);
  const {setWatch} = useContext(ImportWalletTransactionsContext);
  const {close} = useContext(ModalContext);

  const {t} = useTranslation('translation');

  useEffect(() => {
    setWatch(true);
  }, [setWatch]);

  return (
    <Modal title={t('pages.walletImport.title')} onClose={close}>
      <div className='p-4 max-w-[300px] mx-auto space-y-4'>
        <Title>
          {t('pages.walletImport.explanation', {
            nativeTokenSymbol: chain?.nativeCurrency.symbol ?? '',
          })}
        </Title>
        <div className={'h-px w-full bg-gray-600 opacity-20'} />

        {address && (
          <QRCode
            className='px-12 py-4'
            size={256}
            style={{height: 'auto', maxWidth: '100%', width: '100%'}}
            value={address}
            viewBox={'0 0 256 256'}
          />
        )}

        <CopyAddressToClipboardButton />

        <div className={'h-px w-full bg-gray-600 opacity-20'} />

        <div className='flex justify-center text-sm items-center gap-4 text-gray-400 animate-pulse'>
          <GlobeAltIcon className='shrink-0 stroke-gray-400 w-6 h-6' />
          <span className='break-words'>{t('pages.walletImport.watchingTransactions')}</span>
        </div>
      </div>
    </Modal>
  );
};
